import { useState } from 'react';
import axios from 'axios';
import styles from '../../../components/Modal/ConfirmationModal.module.css'
import useLogout from 'src/hooks/useLogout';
import view from '../../../assets/icons/view.svg'
import viewOff from '../../../assets/icons/view-off.svg'
import SuccessCard from 'src/components/Card/SuccessCard';

const ChangePassword = ({isOpen, type}) => {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [username, setUsername] = useState('');
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [hide, setHide] = useState({
    oldPassword: true,
    newPassword: true,
    confirmPassword: true,
  })

  const handleChangePassword = async () => {
    setLoading(true);
    setError('');
    setSuccessMessage('');

    try {
      const response = await axios.post(`${baseUrl}/Account/changePassword`, {
        username,
        OldPassword: oldPassword,
        NewPassword: newPassword,
        ConfirmPassword: confirmPassword,
      });

      const data = response.data;
      if (data.flag) {
        setSuccessMessage('Your password has been changed successfully..');
      } else {
        setError(data.details || 'Password change failed.');
      }
    } catch (error) {
      setError(error?.response?.data?.details);
    } finally {
      setLoading(false);
    }
  };

  const validate = () => {
    if (!username || !oldPassword || !newPassword || !confirmPassword ||loading) {
      return true
    }
    else if (newPassword !== confirmPassword) {
      return true
    }
    else {
      return false
    }
  }

  const logout = useLogout()

  return (
    <main className="bg-body-tertiary d-flex flex-row justify-content-center align-items-center">
     {!successMessage ?
      (<div className='col-9'>
            <form className='my-auto'>
              <div>
                <h6 className='fw-medium fs-3'>Change Password</h6>
                <p className="text-medium-emphasis">Enter your old password and set a new one.</p>
              </div>

              <div>
                <div className='mb-2 d-flex flex-column'>
                  <label className='fw-medium text-start mb-2'>Username</label>
                  <div className={`${styles.modal_password}`}>
                    <input
                      className={`${styles.modalButton} ${styles.modal_password}`}
                      type='email'
                      placeholder="Username"
                      autoComplete="username"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                    />
                  </div>
                </div>

                <div className={`mb-2 d-flex flex-column`}>
                  <label className='fw-medium text-start mb-2'>Old Password</label>
                  <div className={`${styles.modal_password}`}>
                    <input
                      className={`${styles.modalButton} ${styles.modal_password} border-none`}
                      type={hide?.oldPassword ? "password" : "text"}
                      placeholder="enter your old password"
                      autoComplete="current-password"
                      value={oldPassword}
                      onChange={(e) => setOldPassword(e.target.value)}
                    />
                    <img 
                      src={hide?.oldPassword ? view : viewOff} 
                      className={`${styles.modal_password} px-2`}
                      onClick={() => setHide({...hide, oldPassword:!hide.oldPassword})}
                      alt='view password'
                    />
                  </div>
                </div>

                <div className="mb-2 d-flex flex-column">
                  <label className='fw-medium text-start mb-2'>New Password</label>
                  <div className={`${styles.modal_password}`}>
                    <input
                      className={`${styles.modalButton} ${styles.modal_password} border-none`}
                      type={hide?.newPassword ? "password" : "text"}
                      placeholder="enter your new password"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                    />
                    <img 
                      src={hide?.newPassword ? view : viewOff} 
                      className={`${styles.modal_password} px-2`}
                      onClick={() => setHide({...hide, newPassword:!hide.newPassword})}
                      alt='view password'
                    />
                  </div>
                </div>

                <div className="mb-4 d-flex flex-column">
                  <label className='fw-medium text-start mb-2'>Confirm Password</label>
                  <div className={`${styles.modal_password} `}>
                    <input
                      className={`${styles.modalButton} ${styles.modal_password} border-none`}
                      type={hide?.confirmPassword ? "password" : "text"}
                      placeholder="Confirm your new password"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      onBlur={() => (newPassword !== confirmPassword) ? setError("passwords do not match") : setError("")}
                    />
                    <img 
                      src={hide?.confirmPassword ? view : viewOff} 
                      className={`${styles.modal_password} px-2`}
                      onClick={() => setHide({...hide, confirmPassword:!hide.confirmPassword})}
                      alt='view password'
                    />
                  </div>
                </div>

              </div>

              <div>
                <button
                  type='submit'
                  className={`${styles.modalButton} ${ validate() ? styles.modal_password : styles.modal_confirm} mb-2`}
                  onClick={handleChangePassword}
                  disabled={validate()}
                  style={{ backgroundColor: '#521c78', color: validate ? '' :'white' }}
                >
                  {loading ? 'Changing...' : 'Change Password'}
                </button>
              </div>


              
              {error && <p className="text-danger mt-2">{error}</p>}
              {successMessage && <p className="text-success mt-2">{successMessage}</p>}
            </form>
        </div>) : 
      (
        <SuccessCard
          confirm={isOpen}
          logout={logout}
          type= {type}
          successMessage={successMessage}
        />
      )
      }
    </main>
  );
}

export default ChangePassword;
